// @flow
import React, { Component } from 'react'
import { Row, Col } from 'antd'
import { SortingState, RowDetailState, IntegratedSorting } from '@devexpress/dx-react-grid'
import { fetchTrades } from '../../actions/trades'
import moment from 'moment'
import {
    Grid,
    VirtualTable,
    TableHeaderRow,
    TableRowDetail,
    DragDropProvider,
    TableColumnReordering,
    Toolbar,
    TableColumnResizing
} from '@devexpress/dx-react-grid-bootstrap4'
import { PortfoliosGridWrapper } from '../view-positions/style'
import { StyledRow } from './style'


class Overview extends Component<Props, State> {

    state: State = {
        columns: [
            { name: 'tradeDate', title: 'Date' },
            { name: 'action', title: 'Buy/Sell' },
            { name: 'assetType', title: 'Type' },
            { name: 'underlying', title: 'Underlying' },
            { name: 'quantity', title: 'QTY' },
            { name: 'expiration', title: 'EXP Date' },
            { name: 'strike', title: 'Strike' },
            { name: 'price', title: 'Price' },
            { name: 'transactionGroup', title: 'Action Group' }
        ],
        filterMode: 0,
        defaultColumnWidths: [
            { columnName: 'tradeDate', width: 90 },
            { columnName: 'action', width: 100 },
            { columnName: 'assetType', width: 100 },
            { columnName: 'underlying', width: 100 },
            { columnName: 'quantity', width: 100 },
            { columnName: 'expiration', width: 100},
            { columnName: 'strike', width: 100 },
            { columnName: 'price', width: 100 },
            { columnName: 'transactionGroup', width: 100 },
        ],
        details:{},
        rows: [],
        isLoading: true,
    }

    async componentWillMount() {
        const postResponse = await fetchTrades(this.props.tradeId)
        if(postResponse && postResponse.data && postResponse.data.data && postResponse.data.data.portfolio && postResponse.data.data.portfolio.portfolioSnapshot){
            let data = []
            if(postResponse.data.data.portfolio.portfolioSnapshot.length) {
                data = postResponse.data.data.portfolio.portfolioSnapshot
            }
            const trades = data.find(x => x.tradeID === this.props.tradeId)
            this.setState({
                details: trades,
                isLoading: false,
            })
        }
    }

    render() {
        const {columns, defaultColumnWidths, details = {}, isLoading } = this.state
        const rows = (details && details.transactions) || []

        const Cell = (props) => {

            if (
                (props.column.name === 'tradeDate' && props.row.tradeDate) ||
                (props.column.name === 'expiration' && props.row.expiration)) {

                const date: string = props.column.name === 'tradeDate' ? props.row.tradeDate : props.row.expiration
                const day: moment = moment(date).format('MMM-DD-YY')

                return <td>{day}</td>

            }else if (props.column.name === 'price' && props.row.price) {

                return <td>${props.row.price}</td>
            }
            return <VirtualTable.Cell {...props} />

        }

        return (
            <section>
                {
                    isLoading ? <Col span={12} className="loading">Loading....</Col> :
                        <div>
                            <StyledRow gutter={12}>
                                <h1>{details.name}</h1>
                                <Row gutter={12}>
                                    <Col span={6}>
                                        <p>
                                            Open Date : {details.openDate && moment(details.openDate).format('MM/DD/YYYY')}
                                            <br/>
                                            Day in Trade: 1 <br/>
                                            Close Date: {details.closedDate && moment(details.closedDate).format('MM/DD/YYYY')}
                                            <br/>
                                        </p>
                                    </Col>
                                    <Col span={6}>
                                        <p>
                                            Total P/L : ${details.closedProfit || 0} <br/>
                                            Open P/L: ${details.openProfit || 0} <br/>
                                            Closed P/L: ${details.profit || 0} <br/>
                                        </p>
                                    </Col>
                                </Row>
                            </StyledRow>
                            <PortfoliosGridWrapper>
                                <Grid rows={rows} columns={columns}>
                                    <SortingState defaultSorting={[{ columnName: 'tradeDate', direction: 'desc' }]}/>
                                    <RowDetailState />
                                    <IntegratedSorting />
                                    <DragDropProvider />
                                    <VirtualTable cellComponent={Cell} />
                                    <TableColumnReordering defaultOrder={columns.map(column => column.name)} />
                                    <TableColumnResizing defaultColumnWidths={defaultColumnWidths} />
                                    <TableHeaderRow showSortingControls />
                                    <TableRowDetail/>
                                    <Toolbar/>
                                </Grid>
                            </PortfoliosGridWrapper>
                        </div>
                }
            </section>
        )
    }
}

export default Overview


// WEBPACK FOOTER //
// ./src/components/view-trades/Overview.js